import {configureStore} from '@reduxjs/toolkit'
import {botSlice} from "../components/modules/assistant/botSlice";
import {assistantTransferSlice} from "../components/modules/assistant/transfer/assistantTransferSlice";
import {formSlice} from "../components/elements/formProvider/formSlice";
import {botCreateSlice} from "../components/modules/assistant/botCreateSlice";
import {botUpdateSlice} from "../components/modules/assistant/botUpdateSlice";
import {botListSlice} from "../components/modules/assistant/botListSlice";
import {popupModalSlice} from "../components/elements/popupModalProvider/popupModalSlice";
import {platformSlice} from "../components/modules/platform/platformSlice";
import {locationSlice} from "../components/modules/location/locationSlice";
import {locationListSlice} from "../components/modules/location/locationListSlice";
import {locationCreateSlice} from "../components/modules/location/locationCreateSlice";
import {locationUpdateSlice} from "../components/modules/location/locationUpdateSlice";
import {widgetAppearanceSlice} from "../components/modules/assistant/page/widgetSettings/widgetAppearanceUpdateSlice";
import {toolSettingsSlice} from "../components/modules/assistant/page/toolSettings/toolSettingsSlice";
import {transcriptListSlice} from "../components/modules/transcripts/transcriptListSlice";
import {toastNotificationSlice} from "../components/elements/toastNotification/toastNotificationSlice";
import {transcriptSlice} from "../components/modules/transcripts/transcriptSlice";
import {locationOptionsSlice} from "../components/modules/location/locationOptionsSlice";
import {manufacturerVehicleTypesSlice} from "../components/modules/location/manufacturerVehicleTypesSlice";
import {
    newVehicleManufacturerOptionsSlice
} from "../components/modules/franchise/newVehicleManufacturerOptionsSlice";
import {integrationsSlice} from "../components/modules/assistant/page/integrations/slice/integrationsSlice";
import {connectIntegrationSlice} from "../components/modules/assistant/page/integrations/slice/connectIntegrationSlice";
import {updateIntegrationSlice} from "../components/modules/assistant/page/integrations/slice/updateIntegrationSlice";
import {offerListSlice} from "../components/modules/offer/offerListSlice";
import {offerCreateSlice} from "../components/modules/offer/offerCreateSlice";
import {offerUpdateSlice} from "../components/modules/offer/offerUpdateSlice";
import {
    saveNewOffersModalSlice
} from "../components/elements/popupModalProvider/impl/saveNewOffersConfirmationModal/saveNewOffersModalSlice";
import {leadsSlice} from "../components/modules/assistant/page/leads/leadsSlice";
import {analyticsSlice} from "../components/modules/analytics/analyticsSlice";
import {franchiseSlice} from "../components/modules/franchise/franchiseSlice";
import {franchiseCreateSlice} from "../components/modules/franchise/franchiseCreateSlice";
import {franchiseUpdateSlice} from "../components/modules/franchise/franchiseUpdateSlice";
import {transcriptRoutingSlice} from "../components/modules/assistant/page/transcriptRouting/transcriptRoutingSlice";
import {knowledgeDefinitionsSlice} from "../components/modules/knowledge/knowledgeDefinitionsSlice";

export const store = configureStore({
    reducer: {
        bot: botSlice.reducer,
        assistantTransfer: assistantTransferSlice.reducer,
        botCreate: botCreateSlice.reducer,
        botUpdate: botUpdateSlice.reducer,
        botList: botListSlice.reducer,

        integrations: integrationsSlice.reducer,
        connectIntegration: connectIntegrationSlice.reducer,
        updateIntegration: updateIntegrationSlice.reducer,

        widgetAppearance: widgetAppearanceSlice.reducer,
        toolSettings: toolSettingsSlice.reducer,
        leads: leadsSlice.reducer,
        transcriptRouting: transcriptRoutingSlice.reducer,

        location: locationSlice.reducer,
        locationCreate: locationCreateSlice.reducer,
        locationUpdate: locationUpdateSlice.reducer,
        locationList: locationListSlice.reducer,
        locationOptions: locationOptionsSlice.reducer,
        manufacturerVehicleTypes: manufacturerVehicleTypesSlice.reducer,
        newVehicleManufacturerOptions: newVehicleManufacturerOptionsSlice.reducer,

        franchise: franchiseSlice.reducer,
        franchiseCreate: franchiseCreateSlice.reducer,
        franchiseUpdate: franchiseUpdateSlice.reducer,

        knowledgeDefinitions: knowledgeDefinitionsSlice.reducer,

        offerList: offerListSlice.reducer,
        offerCreate: offerCreateSlice.reducer,
        offerUpdate: offerUpdateSlice.reducer,
        saveNewOffersModal: saveNewOffersModalSlice.reducer,

        transcript: transcriptSlice.reducer,
        transcriptList: transcriptListSlice.reducer,
        analytics: analyticsSlice.reducer,

        form: formSlice.reducer,
        toastNotification: toastNotificationSlice.reducer,
        popupModal: popupModalSlice.reducer,
        platform: platformSlice.reducer,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
